<template>
    <v-card min-height="100vh" class="rounded-xl rounded-r-0">
        <v-navigation-drawer app temporary right bottom :value="showApprovalRecordDetails" width="600" stateless>
            <template v-slot:prepend>
                <v-card elevation="0" class="mx-2 my-6">
                    <v-card-title style="padding-top: 0 !important; padding-bottom: 0 !important;">
                        <h6 style="font-size:large;">Request description</h6>
                    </v-card-title>
                    <v-card-text>
                        <p style="display: flex; align-items: center;">
                            <span> request id</span>
                            <span class="divider"></span>
                            <span>requester</span>
                            <span class="divider"></span>
                            <span>requester department</span>
                        </p>
                    </v-card-text>
                </v-card>
            </template>


            <v-card elevation="0" class="ma-6">
                <div style="display: flex; justify-content: space-between; align-items: center;">
                    <h5 style="display: flex; flex-direction: column; font-size: large;">
                        <span style="font-weight:600;">
                            Amount
                        </span>
                        <span>
                            KES 32000
                        </span>
                    </h5>
                    <v-chip outlined class="ma-2" color="success"> status</v-chip>
                </div>
            </v-card>

            <v-card elevation="0" class="ma-6">
                <div>
                    <h5>Attachments</h5>
                    <div v-for="att in [{ name: 'attachment 1', size: '512kb', id: 1 }, { name: 'attachment 2', size: '220kb', id: 2 }, { name: 'attachment 1', size: '512kb', id: 3 }]"
                        :key="att.id" style="display: flex; justify-content: space-between; margin: 16px 0">
                        <span>
                            <span><v-icon color="black">mdi-file-document</v-icon></span>
                            <span>{{ att.name }}</span>
                        </span>
                        <span>{{ att.size }}</span>
                    </div>
                </div>
            </v-card>
            <v-card class="ma-6" elevation="0">
                <div>
                    <h5>Notes</h5>
                    <p> thiese are custo notes dropped here by applicant making application to the original document
                        before it was
                        sent for approval</p>
                </div>
            </v-card>
            <ContexualApproval />
        </v-navigation-drawer>
    </v-card>
</template>

<script>
import ContexualApproval from './ContexualApproval.vue';
export default {
    name: 'ApprovalDetailsDrawer',

    props: {
        showApprovalRecordDetails: {
            type: Boolean,
            default: false,
        },
    },
    components: { ContexualApproval },
    data() {
        return {
            items: [
                { title: 'Home', icon: 'mdi-home-city' },
                { title: 'My Account', icon: 'mdi-account' },
                { title: 'Users', icon: 'mdi-account-group-outline' },
            ],
        }
    },

    mounted() {
        document.addEventListener('click', this.drawerStateHandler);
    },
    methods: {
        drawerStateHandler(event) {
            event.preventDefault();
            event.stopPropagation();
            if (event.target.className === 'v-overlay__scrim') {
                this.$emit('toggle-approval-details-drawer', {}, false);
            }
        }
    }
}
</script>

<style scope>
.divider {
    display: inline-block;
    margin-inline: 4px;
    background-color: rgba(0, 0, 0, 0.573);
    width: 4px;
    height: 4px;
    border-radius: 50%;
}
</style>